import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHFortySixPreLogin',
    name: 'IFPageOneHFortySixPreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortySix/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHFortySixLogin' ||
        from.path === '/IFPageOneHFortySixLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHFortySixLogin',
    name: 'pageOneHFortySixLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFortySix/login.vue'),
  },
  {
    path: '/IFPageOneHFortySixLoginLoading',
    name: 'pageOneHFortySixLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFortySix/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHFortySixLeaveInfo',
    name: 'pageOneHFortySixLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortySix/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHFortySixResult',
    name: 'pageOneHFortySixResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortySix/result.vue'),
  },
  {
    path: '/IFPageOneHFortySixLoading',
    name: 'pageOneHFortySixLoading',
    component: () => import('@/pages/pageListAll/pageOneHFortySix/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHFortySixLoginSecond',
    name: 'pageOneHFortySixLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHFortySix/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortySixOnline',
    name: 'pageOneHFortySixOnline',
    component: () => import('@/pages/pageListAll/pageOneHFortySix/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHFortySixLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHFortySixGuide',
    name: 'pageOneHFortySixLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHFortySix/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageOneHFortySixCar',
    name: 'pageOneHFortySixCar',
    component: () => import('@/pages/pageListAll/pageOneHFortySix/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHFortySixCarDetails',
    name: 'pageOneHFortySixCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHFortySix/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },
  {
    path: '/IFPageOneHFortySixBlank',
    name: 'pageOneHFortySixBlank',
    component: () => import('@/pages/pageListAll/pageOneHFortySix/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortySixOnlineTab',
    name: 'pageOneHFortySixOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHFortySix/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortySixOnlineAd',
    name: 'pageOneHFortySixOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHFortySix/onlineAd.vue'),
    meta: {
      title: projectName,
    },
  },
];
